import RNMsgChannel from 'react-native-webview-messaging';
import apiService from '../../services/ApiService';

const downloadUtils = {
    downloadFinishedCallback: undefined,
    isNewApp: true,
    isInitialized: false,

    checkType() {
        return;
        RNMsgChannel.on('text', this.onCheckAppType.bind(this));
        RNMsgChannel.send('IsRecordingEnabled');
    },
    onCheckAppType(e) {
        if (e == 'IsRecordingEnabled' || e == 'IsRecordingDisabled')
            this.isNewApp = false;
    },

    download(downloadId) {
        if (!this.isInitialized) {
            if (!this.isNewApp)
                RNMsgChannel.on('text', this.onMessageReceivedFromRN.bind(this));
            else
                window.addEventListener('message', this.getMessageFromRN.bind(this));

            this.isInitialized = true;
        }

        // var videoUrl;
        //
        // if (configuration.IS_PROD())
        //     videoUrl = 'https://www.creaza.com/file/ci/' + downloadId + '/';
        // else
        //     videoUrl = 'https://stage.creaza.com/file/ci/' + downloadId + '/';
        //
        // var message = 'Download=' + videoUrl;
        //
        // if (!this.isNewApp)
        //     RNMsgChannel.send(message);
        // else
        //     window.postMessage(message);

        apiService.getSignedContent([downloadId])
            .then(response => {
                var videoUrl = response[downloadId];
                var message = 'Download=' + videoUrl;

                if (!this.isNewApp)
                    RNMsgChannel.send(message);
                else
                    window.ReactNativeWebView.postMessage(message);
            });
    },
    onMessageReceivedFromRN(text) {
        if (text == 'DownloadFinished' && this.downloadFinishedCallback) {
            this.downloadFinishedCallback();
        }
    },
    getMessageFromRN(e) {
        var text = e.data;

        if (text == 'DownloadFinished' && this.downloadFinishedCallback)
            this.downloadFinishedCallback();
    }
};

export default downloadUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/DownloadUtils.js
 **/